export const NOTIFICATION_TYPE = {
    ERROR: "error",
    WARNING: "warning",
    SUCCESS: "success",
}